import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Scrolling,
  SearchPanel,
  Selection,
} from "devextreme-react/data-grid";
import { useEffect, useState } from "react";
import styled from "styled-components";

const RawDataWrapper = styled.div`
  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
  .dx-button {
    margin: 0 5px;
    float: left;
  }
  #infoButton {
    i {
      font-size: inherit;
    }
  }
  .edit-status-col {
    padding: 0 !important;
  }
  #rawDataGrid {
    max-width: 99vw;
  }
`;

export default function RawData() {
  const [rawDataSource, setRawDataSource] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BECCO_API_URL}/api/workR/rawData`)
      .then((res) => {
        setRawDataSource(res.data);
      });
  }, []);

  return (
    <RawDataWrapper>
      <DataGrid
        id="rawDataGrid"
        dataSource={rawDataSource}
        keyExpr={"id"}
        showBorders={true}
        showColumnLines={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        width={"100%"}
        wordWrapEnabled={true}
        allowColumnReordering={true}
        height={"auto"}
        style={{
          maxHeight: `calc(100vh - 260px)`,
          // marginLeft: "10px",
          // marginRight: "10px",
        }}
      >
        <LoadPanel enabled={true} />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} />
        <Scrolling mode={"virtual"} showScrollbar={"always"} />
        <Selection mode={"single"} />

        <Export enabled={true} />

        <Column
          dataField={"id"}
          caption={"ID"}
          dataType={"number"}
          width={65}
        />
        <Column dataField={"employeeNo"} caption={"Employee No."} width={120} />
        <Column dataField={"name"} caption={"Employee Name"} width={100} />
        <Column dataField={"div"} caption={"Division"} width={90} />
        <Column
          dataField={"classifWork"}
          caption={"Classification of Work"}
          width={125}
        />
        <Column dataField={"projName"} caption={"Project Name"} width={300} />
        <Column dataField={"quotNo"} caption={"Quotation No."} width={100} />
        <Column dataField={"codeNo"} caption={"Code No."} width={100} />
        <Column dataField={"taskCat"} caption={"Task Category"} width={300} />
        <Column dataField={"SEQ"} caption={"SEQ"} width={70} />
        <Column dataField={"detTask"} caption={"Detailed Task"} width={300} />
        <Column dataField={"subject"} caption={"Subject"} width={300} />
        <Column
          dataField={"startDate"}
          caption={"Start Date"}
          dataType={"date"}
          format={"yyyy-MM-dd"}
          width={100}
        />
        <Column
          dataField={"endDate"}
          caption={"End Date"}
          dataType={"date"}
          format={"yyyy-MM-dd"}
          width={100}
        />

        <Column dataField={"descr"} caption={"Description"} width={300} />
      </DataGrid>
    </RawDataWrapper>
  );
}
